import React, { useCallback, useContext } from "react";
import { withRouter, Redirect } from "react-router";
import firebase from "../../firebase";
import { AuthContext } from "./Auth.js";
import AcademyNavbar from './AcademyNavbar'

const Login = ({ history }) => {
  const handleLogin = useCallback(
    async event => {
      event.preventDefault();
      const { email, password } = event.target.elements;
      try {
        await firebase
          .auth()
          .signInWithEmailAndPassword(email.value, password.value);
        //   pushing to '/dashobard' when user logs-in
        history.push("/dashboard/");
      } catch (error) {
        alert(error);
      }
    },
    [history]
  );


  const { currentUser } = useContext(AuthContext);

//   if user is already logged in
  if (currentUser) {
    return <Redirect to="/dashboard/" />;
  }

  return (
    <>
    <AcademyNavbar />
    <div className="container text-white d-flex" style={{height: '100vh', alignItems: 'center'}}>
      <div className="row justify-content-center" style={{flex: '1'}}>
        <div className="col-12 col-md-8 col-lg-8 col-xl-6">
          <h1>Log in</h1>
          <form onSubmit={handleLogin}>
            <div class="form-group">
              <label for="inputEmail">Email address</label>
              <input type="email" name="email" class="form-control" id="inputEmail" aria-describedby="emailHelp" placeholder="Enter email" />
            </div>
            <div class="form-group">
              <label for="inputPassword">Password</label>
              <input type="password" name="password" class="form-control" id="inputPassword" aria-describedby="passwordHelp" placeholder="Enter password" />
              <a href="#" onClick={(e) => {e.preventDefault(); history.push('/resetpassword/')} }>Forgot Password</a>
            </div>
            <div className="d-flex justify-content-around">
              <button className="btn btn-primary" type="submit">Login</button>

              <button className="btn btn-light" type="button" onClick={() => {history.push('/signup/')} }>Sign Up</button>
            </div>
          </form>

        </div>
      </div>
    </div>
    </>
  );
};

export default withRouter(Login);